import React from 'react';
import { Navigate } from 'react-router-dom';

const readPersistedSession = () => {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('vincentrix_token');
    const dealerRaw = localStorage.getItem('dealer') || localStorage.getItem('dealership') || localStorage.getItem('vincentrix_dealer');
    if (!token || !dealerRaw) return null;

    const dealer = JSON.parse(dealerRaw);
    if (!dealer || !dealer.id) return null;

    return dealer;
  } catch (error) {
    console.warn('Unable to restore VinCentrix session:', error);
    return null;
  }
};

const ProtectedRoute = ({ children, user }) => {
  const authenticatedUser = user || readPersistedSession();

  if (!authenticatedUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
